var l = /* @__PURE__ */ ((a) => (a.article = "article", a.news = "news", a.podcast = "podcast", a.all = "all", a))(l || {});
export {
  l as ListType
};
